module.exports = __webpack_public_path__ + "static/media/beep_error.4e2d89ba.ogg";